import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../../components/UiComponent/customTable";
import useUserApi from "../../../services/userApi";
import { useQuery } from "@tanstack/react-query";
import {
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import Card from "../../../components/Card";
import CustomModal from "../../../components/UiComponent/Modal";
import UserAdd from "./UserAdd";
import exportToExcel from "../../../utils/exportToExcel";
const UserList = () => {
  const { all_user } = useUserApi();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const getUserQuery = useQuery(["get_all_user"], () => all_user());

  const userData = useMemo(() => {
    return getUserQuery.data || [];
  }, [getUserQuery.data]);
  if (getUserQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getUserQuery.isError) {
    return <div>Error: {getUserQuery.error.message}</div>;
  }
  const handleEdit = (event, rowItem) => {
    event.preventDefault();
  };
  const userColumns = [
    {
      header: "full_name",
      accessorFn: (row) =>
        `${row.employee.first_name} ${row.employee.father_name}`,
    },
    {
      header: "username",
      accessorKey: "username",
    },
    {
      header: "phone",
      accessorKey: "employee.phone",
    },
    {
      header: "role",
      accessorFn: (row) => `${row.role?.name}`,
    },
    {
      header: "action",
      accessor: "id",
      cell: (row) => (
        <div className="d-flex justify-content align-items-center">
          <OverlayTrigger placement={"top"} overlay={<Tooltip>View</Tooltip>}>
            <Button
              className="badge bg-success-light mr-2"
              variant="btn"
              onClick={(e) => handleEdit(e, row)}
            >
              <i className="lar la-eye"></i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Define export columns (reuse this config wherever needed)
  const userExportColumns = [
    {
      header: "Full Name",
      key: (row) => `${row.employee.first_name} ${row.employee.father_name}`,
    },
    { header: "Username", key: "username" },
    { header: "Phone", key: "employee.phone" },
    { header: "Role", key: (row) => row.role?.name || "" },
  ];

  const handleExport = () => {
    exportToExcel({
      data: userData,
      columnsConfig: userExportColumns,
      fileName: "users_list",
      sheetName: "Users",
      columnWidths: [
        { wch: 25 }, // Full Name
        { wch: 20 }, // Username
        { wch: 15 }, // Phone
        { wch: 20 }, // Role
      ],
    });
  };
  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <Card className="card-block card-stretch card-height">
              <Card.Body>
                <BasicTable
                  data={userData}
                  columns={userColumns}
                  title={`user_list`}
                  actionButton={
                    <div>
                      <Button
                        variant="btn btn-success btn-sm"
                        onClick={handleExport}
                      >
                        <i className="las la-file-excel mr-1"></i>
                        {t("export") || "Export to Excel"}
                      </Button>
                      <Button
                        variant="btn btn-info btn-sm m-2"
                        onClick={() => handleShowModal()}
                      >
                        {t("add_new_user")}
                      </Button>
                    </div>
                  }
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <CustomModal
        show={showModal}
        title="add_new_user_form"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <UserAdd onSubmitButton={handleButtonSubmit} parentID={"id"} />
        }
      />
    </>
  );
};

export default UserList;
